var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPriceLink)?_c('link-button',{attrs:{"to":`${_vm.cloudRegionHost}/price`,"target":"_blank","kind":"light"}},[_vm._v("\n  "+_vm._s(_vm.$trlMessage('promo.details'))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }